<app-section #parentSection
             [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [title]="title | translate"
             class="address-data"
             [containerClass]="false"
             [key]="key">

  <ng-template #section>

    <div class="col">
      <div class="section__component col-33">
        <app-text-field
                [errorsMap]="formFactoryService.errorsMap"
                [control]="formGroup.controls[consts.FIRST_NAME]"
                [fieldConfig]="formFactoryService.fieldConfig(consts.FIRST_NAME, formConfig)"
                [context]="formConfig.formKey"
        >
        </app-text-field>
      </div>
      <div class="section__component col-33">
        <app-text-field
                [errorsMap]="formFactoryService.errorsMap"
                [control]="formGroup.controls[consts.LAST_NAME]"
                [fieldConfig]="formFactoryService.fieldConfig(consts.LAST_NAME, formConfig)"
                [context]="formConfig.formKey"
        >
        </app-text-field>
      </div>
      <div class="section__component col-33">
        <app-text-field [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.PESEL]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.PESEL, formConfig)"
                        [context]="formConfig.formKey"
        >
        </app-text-field>
      </div>
      <div class="section__component col-33">
        <app-text-field [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.POSTAL_CODE]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.POSTAL_CODE, formConfig)"
                        [context]="formConfig.formKey"
        >
        </app-text-field>
      </div>
      <div class="section__component col-33">
        <app-text-field [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.CITY]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.CITY, formConfig)"
                        [context]="formConfig.formKey"
        >
        </app-text-field>
      </div>
      <div class="section__component col-33">
        <app-text-field [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.STREET]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.STREET, formConfig)"
                        [context]="formConfig.formKey"
        >
        </app-text-field>
      </div>
      <div class="section__component col-33">
        <app-text-field [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.BUILDING_NUMBER]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.BUILDING_NUMBER, formConfig)"
                        [context]="formConfig.formKey"
        >
        </app-text-field>
      </div>
      <div class="section__component col-33">
        <app-text-field [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.FLAT_NUMBER]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.FLAT_NUMBER, formConfig)"
                        [context]="formConfig.formKey"
        >
        </app-text-field>
      </div>
    </div>

  </ng-template>
</app-section>
